export function checkValidPathname(pathname: string) {
  const rootPathName = pathname == ''
  if (rootPathName) return null;

  const pathnameStartsWithWpPrefix = pathname.startsWith('wp-')
  if (pathnameStartsWithWpPrefix) {
    return 'Страницы начинающие с "wp-" не доступны'
  }

  const pathnameStartsAdminWord = pathname.startsWith('admin')
  if (pathnameStartsAdminWord) {
    return 'Страницы начинающие с "admin" не доступны'
  }

  const pathnameIncludesOnlyEnglishLettersNumbersAndTire = (/^[a-z0-9-]*$/.test(pathname))
  if (!pathnameIncludesOnlyEnglishLettersNumbersAndTire) {
    return 'В url могут быть только цифры, английские прописные буквы и тире'
  }

  return null;
}
